<template>
  <v-radio-group row class="imd-sm-radio"
    :value="value"
    @change="v=>this.$emit('input', v)"
  >
    <slot></slot>
  </v-radio-group>
</template>


<style>
/* 중간정렬 */
.imd-sm-radio { vertical-align: middle; }
/* wrap */
.imd-sm-radio.v-input--selection-controls { overflow: visible; height: unset;  margin:-1px 0px -14px 0; padding: 0;}
/* 아이콘 */
.imd-sm-radio .v-icon { font-size: 21px; margin-top: -3px; }
.imd-sm-radio .v-input--selection-controls__input { margin: 0 1px 0 0; height: unset;  }
/* 라벨 */
.imd-sm-radio .v-label { font-size: 12px; font-Family: Gulim, '굴림', dotum,'돋움', AppleGothic, sans-serif; margin-top: -2px; }
/* 클릭했을때 번쩍이는 효과 범위 */
.imd-sm-radio .v-input--selection-controls__ripple {
  height: 21px;
  width: 21px;
  left: -7px;
  top: calc(50% - 18px);
}
/* 우측 라디오하고 간격 */
.imd-sm-radio .v-radio { margin-right: 6px; }
/* 안쓰는 부분 */
.imd-sm-radio .v-messages { display: none; }

</style>

<script>
  export default {
    props: ['value', 'items'],
  }
</script>
